"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HandlerRole;
(function (HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})(HandlerRole = exports.HandlerRole || (exports.HandlerRole = {}));
//# sourceMappingURL=interfaces.js.map


//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/lib/interfaces.js
// module id = 702
// module chunks = 0